import {
  convocatoria001,
  convocatoria002,
  convocatoria003,
  n1,
  n2,
  n3,
  n4,
  n5,
  n6,
  convocatoriaLOP001,
  lop1,
  convocatoria004,
  n7,
  convocatoria005,
n8,
n9,
n10,
n11

} from "../../json/anioLicitaciones/2024/anioLicitacion2024";

export const obtenerDatosSeleccionados = (selectedItemIndex) => {
  let datosSeleccionados = [];

  switch (selectedItemIndex) {
    case "Convocatoria 01-2024":
      datosSeleccionados = convocatoria001;
      break;
    case "Convocatoria 02-2024":
      datosSeleccionados = convocatoria002;
      break;
    case "Convocatoria 03-2024":
      datosSeleccionados = convocatoria003;
      break;
    case "EA-913005999-N1-2024":
      datosSeleccionados = n1;
      break;
    case "EA-913005999-N2-2024":
      datosSeleccionados = n2;
      break;
    case "EA-913005999-N3-2024":
      datosSeleccionados = n3;
      break;
    case "EA-913005999-N4-2024":
      datosSeleccionados = n4;
      break;
    case "EA-913005999-N5-2024":
      datosSeleccionados = n5;
      break;
    case "EA-913005999-N6-2024":
      datosSeleccionados = n6;
      break;
    case "Convocatoria 01-2024 OBRA":
      datosSeleccionados = convocatoriaLOP001;
      break;
    case "CAASIM-HGO-L.O.P.-01-2024":
      datosSeleccionados = lop1;
      break;
    case "Convocatoria 04-2024":
      datosSeleccionados = convocatoria004;
      break;
    case "EA-913005999-N7-2024":
      datosSeleccionados = n7;
      break;
    case "Convocatoria 05-2024":
      datosSeleccionados = convocatoria005;
      break;


      case "EA-913005999-N8-2024":
        datosSeleccionados = n8;
        break;

        case "EA-913005999-N9-2024":
          datosSeleccionados = n9;
          break;

          case "EA-913005999-N10-2024":
            datosSeleccionados = n10;
            break;

            case "EA-913005999-N11-2024":
              datosSeleccionados = n11;
              break;
        


    default:
      datosSeleccionados = [];
  }

  return datosSeleccionados;
};
